import styles from '../centralAntrag.module.css';
import { useEffect, useState } from "react";
import { accept, shirt } from '../../../../../config/meta-informationen';
import LogoInformationText from '../../../../components/LogoInformationText/LogoInformationText';
import { showErrorToast } from '../../../../../code/ToastHelper';

function AnmeldungCamp() {
    const [submitted, setSubmitted] = useState(false);
    const [camps, setCamps] = useState([]);
    const [selectedCamp, setSelectedCamp] = useState(null); // camp object
    const [isFull, setIsFull] = useState(false);
    const [formData, setFormData] = useState({
        formType: "campAnmeldung",
        campID: "",
        titleCamp: "",
        vornameKind: "",
        nachnameKind: "",
        birthdate: "",
        mitglied: "",
        email: "",
        shirt: "",
        vornameErziehung: "",
        nachnameErziehung: "",
        telefon: "",
        street: "",
        housenumber: "",
        zusatz: "",
        plz: "",
        area: "",
        eatingHabit: "",
        allergies: "",
        sickness: "",
        bemerkung: "",
    });

    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        const today = new Date();
        today.setFullYear(today.getFullYear() - 5);
        const max = today.toISOString().split('T')[0]; // Format to "YYYY-MM-DD"
        setMaxDate(max);
    }, []);
    useEffect(() => {
        const fetchCamps = async () => {
            try {
                const response = await fetch("/api/camp");
                if (!response.ok) {
                    throw new Error("Failed to fetch camps");
                }
                const data = await response.json();
                setCamps(data);
                // ✅ Check URL hash and pre-select the camp
                const hash = window.location.hash.replace("#", "");
                if (hash) {
                    const matchedCamp = data.find(camp => camp.slug === hash);
                    if (matchedCamp) {
                        setFormData(prev => ({ ...prev, campID: matchedCamp.id }));
                    }
                }
            } catch (error) {
                console.error("Error fetching camps:", error);
            }
        };

        fetchCamps();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "campID") {
            const selected = camps.find(c => c.id.toString() === value);
            setSelectedCamp(selected);
            checkIfCampIsFull(selected);
            setFormData((prev) => ({
                ...prev,
                campID: value,
                titleCamp: selected?.title || "" // set titleCamp too
            }));
            return;
        }

        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const checkIfCampIsFull = async (camp) => {
        if (!camp?.id) return;

        try {
            const res = await fetch(`/api/participant/count/by-camp?camp_id=${camp.id}`);
            if (!res.ok) throw new Error("Error fetching participant count");

            const data = await res.json(); // ✅ only call once
            if (data.count >= camp.max_participants) {
                setIsFull(true);
            } else {
                setIsFull(false);
            }
        } catch (err) {
            console.error("Fehler beim Prüfen der Teilnehmerzahl:", err);
            setIsFull(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // 1. Create participant
            const participantRes = await fetch("/api/participant", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (!participantRes.ok) {
                throw new Error("Fehler beim Erstellen des Teilnehmers");
            }

            const participant = await participantRes.json();

            try {
                // 2. Send email
                const emailRes = await fetch("/api/email/send-emails", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                });

                if (emailRes.ok) {
                    setSubmitted(true);
                } else {
                    // Rollback: delete participant
                    const deleteRes = await fetch(`/api/participant/${participant.id}`, {
                        method: "DELETE",
                    });

                    if (!deleteRes.ok) {
                        console.error("Fehler beim Löschen des Teilnehmers:", await deleteRes.text());
                    }
                    showErrorToast("Senden der E-Mail ist fehlgeschlagen! Versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an die Geschäftsstelle.");
                }
            } catch (emailError) {
                console.error("Fehler beim E-Mail-Versand:", emailError);

                const deleteRes = await fetch(`/api/participant/${participant.id}`, {
                    method: "DELETE",
                });

                if (!deleteRes.ok) {
                    console.error("Fehler beim Löschen des Teilnehmers:", await deleteRes.text());
                }
                showErrorToast("Senden der E-Mail ist fehlgeschlagen. Bitte überprüfen Sie die E-Mail-Adresse oder kontaktieren Sie uns direkt.");
            }

        } catch (participantError) {
            console.error("Fehler beim Erstellen des Teilnehmers:", participantError);
            showErrorToast("Fehler beim Erstellen des Teilnehmers. Bitte kontaktieren Sie den Administrator.");
        }
    };
    if (camps.length === 0) {
        return (
            <section className={styles.container}>
                <h1>Campanmeldung</h1>
                <LogoInformationText>

                    <p><strong>Aktuell stehen keine Camps aus.</strong></p>
                    <p>Sobald ein Camp in den News angekündigt ist, können Sie hier ihr Kind anmelden.</p>
                    <p>Bis bald.</p>

                </LogoInformationText>
            </section>
        )
    }

    return (
        <section className={styles.container}>
            <h1>Anmeldung: Camp</h1>

            {!submitted ? (
                <>
                    <form className={styles.formular} onSubmit={handleSubmit}>
                        <div className={styles.section}>
                            <p className={styles.sectionTitle}>Zu welchem Camp möchten Sie ihr Kind anmelden?</p>
                            <div className={styles.area}>
                                <select
                                    name="campID"
                                    value={formData.campID}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Wähle ein Camp</option>
                                    {camps.map((c) => (
                                        <option key={c.id} value={c.id}>
                                            {c.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </form>
                    {isFull && selectedCamp && (
                        <LogoInformationText>
                            <p><strong>Leider sind alle Plätze für das {selectedCamp.title} belegt.</strong></p>
                            <p>Schauen Sie gerne immer wieder mal hinein. Bei Abmeldungen werden hier wieder neue Plätze frei.</p>
                            <p>Bis bald.</p>
                        </LogoInformationText>
                    )}
                    {formData.campID && !isFull && (
                        <form className={styles.formular} onSubmit={handleSubmit}>

                            <div className={styles.section}>
                                <p className={styles.sectionTitle}>Allgemeine Informationen: Kind</p>
                                <div className={styles.area}>
                                    <label>
                                        <div>Vorname <span className={styles.required}>*</span></div>
                                        <input type="text" name="vornameKind" placeholder='Max' required onChange={handleChange} />
                                    </label>
                                    <label>
                                        <div>Nachname <span className={styles.required}>*</span></div>
                                        <input type="text" name="nachnameKind" placeholder='Mustermann' required onChange={handleChange} />
                                    </label>
                                </div>

                                <div className={styles.area}>
                                    <label>
                                        <div>Geburtsdatum Kind <span className={styles.required}>*</span></div>
                                        <input type="date" name="birthdate" required max={maxDate} onChange={handleChange} />

                                    </label>
                                    <label>
                                        <div>T-Shirt Größe<span className={styles.required}>*</span></div>

                                        <select
                                            name="shirt"
                                            value={formData.shirt}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="" disabled>Wähle die passende Größe...</option>
                                            {Object.keys(shirt).map((key) => (
                                                <option key={key} value={key}>
                                                    {shirt[key]}
                                                </option>
                                            ))}
                                        </select>
                                    </label>
                                    <div className={styles.areaSpecial} >
                                        <div>Mitglied beim TuS 05?<span className={styles.required}>*</span></div>
                                        {Object.entries(accept).map(([key, label], index) => (
                                            <label key={key}>
                                                <input type="radio" name="mitglied" value={key} onChange={handleChange}
                                                    required={index === 0} />
                                                {label}
                                            </label>
                                        ))}
                                    </div>

                                </div>
                            </div>
                            <div className={styles.section}>
                                <p className={styles.sectionTitle}>Allgemeine Informationen: Elternteil</p>
                                <div className={styles.area}>
                                    <label>
                                        <div>Vorname <span className={styles.required}>*</span></div>
                                        <input type="text" name="vornameErziehung" placeholder='Max' required onChange={handleChange} />
                                    </label>
                                    <label>
                                        <div>Nachname <span className={styles.required}>*</span></div>
                                        <input type="text" name="nachnameErziehung" placeholder='Mustermann' required onChange={handleChange} />
                                    </label>
                                </div>
                                <div className={styles.area}>
                                    <label>
                                        <div>E-Mail<span className={styles.required}>*</span></div>
                                        <input type="email" name="email" placeholder='max.mustermann@muster-adresse.de' required onChange={handleChange} />
                                    </label>
                                    <label>
                                        <div>Telefonnummer<span className={styles.required}>*</span></div>
                                        <input type="tel" name="telefon" placeholder='0177123456789' required onChange={handleChange} />
                                    </label>
                                </div>
                            </div>
                            <div className={styles.section}>
                                <p className={styles.sectionTitle}>Adresse</p>
                                <div className={styles.area}>
                                    <label className={styles.big}>
                                        <div>Straße<span className={styles.required}>*</span></div>
                                        <input type="text" name="street" placeholder='Musterstraße' required onChange={handleChange} />
                                    </label>
                                    <label className={styles.small}>
                                        <div>Hausnummer<span className={styles.required}>*</span></div>
                                        <input type="text" name="housenumber" placeholder='3a' required onChange={handleChange} />
                                    </label>
                                </div>
                                <div className={styles.area}>
                                    <label>
                                        <div>Zusatz</div>
                                        <input type="text" name="zusatz" placeholder='Hinterhof' onChange={handleChange} />
                                    </label>
                                </div>
                                <div className={styles.area}>
                                    <label className={styles.small}>
                                        <div>PLZ<span className={styles.required}>*</span></div>
                                        <input type="text" name="plz" placeholder='53639' pattern="\d{5}" required onChange={handleChange}
                                            maxLength={5}
                                            inputMode="numeric"
                                            title="Bitte eine fünfstellige Postleitzahl eingeben"
                                        />
                                    </label>
                                    <label className={styles.big}>
                                        <div>Ort<span className={styles.required}>*</span></div>
                                        <input type="text" name="area" placeholder='Königswinter' required onChange={handleChange} />
                                    </label>
                                </div>
                            </div>
                            <div className={styles.section}>
                                <p className={styles.sectionTitle}>Wichtige Informationen</p>
                                <div className={styles.area}>
                                    <label>
                                        <div>Essgewohnheiten</div>
                                        <textarea className={styles.textareaSmall} name="eatingHabit" placeholder="Schreibe hier nennenswerte Essgewohnheiten..." onChange={handleChange}></textarea>
                                    </label>
                                </div>
                                <div className={styles.area}>
                                    <label>
                                        <div>Allergien</div>
                                        <textarea className={styles.textareaSmall} name="allergies" placeholder="Nussallergie" onChange={handleChange}></textarea>
                                    </label>
                                </div>
                                <div className={styles.area}>
                                    <label>
                                        <div>Krankheiten</div>
                                        <textarea className={styles.textareaSmall} name="sickness" placeholder="Schreibe hier nennenswerte Krankheit des Kindes..." onChange={handleChange}></textarea>

                                    </label>
                                </div>
                            </div>
                            <div className={styles.section}>
                                <p className={styles.sectionTitle}>Bemerkungen</p>
                                <div className={styles.area}>
                                    <label>
                                        <div></div>
                                        <textarea name="bemerkung" placeholder="Schreibe hier deine Bermerkung..." onChange={handleChange}></textarea>
                                    </label>
                                </div>
                            </div>
                            <button type="submit">Absenden</button>
                        </form>
                    )}
                </>
            ) : (
                <div className={styles.bestaetigung}>
                    <img src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                    <div className={styles.text}>
                        <p>Die Kursanmeldung wurde erfolgreich übermittelt!</p>
                        <p>Sie erhalten zusätzlich eine Bestätigung per E-Mail.</p>
                    </div>
                    <img className={styles.secondImg} src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                </div>
            )}
        </section >
    )
}

export default AnmeldungCamp;